import {Card, Stack, Typography, styled} from '@mui/material';

const StyledCard = styled(Card)`
	padding: 16px;
	display: flex;
	flex-direction: column;
	gap: 16px;
	border-radius: 8px;
	box-shadow: none;

	${({theme}) => theme.breakpoints.up('md')} {
		padding: 32px 32px 40px;
	}
`;

const StyledCardContent = styled(Stack)`
	gap: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		gap: 48px;
	}
`;

const StyledTitle = styled(Typography)`
	text-align: center;
	font-size: 1.25rem;
	line-height: 160%;
	letter-spacing: 0.15px;

	${({theme}) => theme.breakpoints.up('lg')} {
		font-size: 1.5rem;
		line-height: 133.4%;
	}
`;

const StyledDescription = styled(Typography)`
	text-align: center;
	font-size: 1rem;
	line-height: 150%;
	letter-spacing: 0.15px;

	${({theme}) => theme.breakpoints.up('lg')} {
		line-height: 175%;
	}
`;

export {StyledCard, StyledCardContent, StyledTitle, StyledDescription};
